const compatModules = {};import * as Mod1 from "./lib/discourse-markdown/bbcode-color";
compatModules["lib/discourse-markdown/bbcode-color"] = Mod1;

export * as lib$discourse__markdown$bbcode__color$$__module from "./lib/discourse-markdown/bbcode-color";
export {
setup as lib$discourse__markdown$bbcode__color$$setup
} from "./lib/discourse-markdown/bbcode-color";
export default compatModules;
